export const environment = {
  backendUrl: 'https://sales-api.blackhawkcollision.com/',
  production: true,
  projectName: 'blackhawk'
};
